<template>
    <div class="pricing-plans row no-gutters">
        <div class="pricing-plan col-sm-12">
            <div class="plan-head user-profile compact">
                <div class="up-head-w" >
                    <div class="up-main-info">
                      <img :src="session.channel_logo" width="200px" class="mb-4">
                      <br />
                        <h2 class="up-header">Session
                            <span v-html="getSessionID(session)" />
                        </h2>
                        <h6 class="up-sub-header">
                            <div class="value badge badge-pill bold text-capitalize">{{session.type}} Session</div>
                        </h6>
                        <h6 class="up-sub-header">
                            <div class="value badge badge-pill bold text-capitalize">{{session.created_at}}</div>
                        </h6>

                    </div>
                </div>
            </div>
            <div class="plan-body">
                <div class="row m-b">
                    <div class="col-sm-6 b-r b-b">
                        <div class="el-tablo centered padded-v">
                            <div class="value">{{products}}</div>
                            <div class="label">Products</div>
                        </div>
                    </div>
                    <div class="col-sm-6 b-b">
                        <div class="el-tablo centered padded-v">
                            <div class="value text-capitalize" :class="formatStatus(session.status)">{{formatStatus(session.status)}}</div>
                            <div class="label">Status</div>
                        </div>
                    </div>
                </div>
                <div class="plan-btn-w" v-if="session.status == 1 && type == 'copydesk'">
                    <router-link :to="`/${type}/sessions/${subtype}/${getSessionID(session)}/add`">
                        <a class="btn btn-primary btn-rounded text-white">Add Products</a>
                    </router-link>
                </div>
                <div class="plan-btn-w" v-if="session.status == 1 && type != 'copydesk'">
                    <router-link :to="`/${type}/sessions/${getSessionID(session)}/import`" v-if="session.type == 'bulk_import' && session.status == 1">
                        <a class="btn btn-primary btn-rounded text-white">Import Products</a>
                    </router-link>

                    <router-link :to="`/${type}/sessions/${getSessionID(session)}/add`" v-else>
                        <a class="btn btn-primary btn-rounded text-white">Add Products</a>
                    </router-link>
                </div>
                <div class="plan-btn-w" v-if="session.status == 1">
                    <a @click="closeSession" class="btn btn-secondary btn-rounded text-white">Close Session</a>
                </div>
            </div>
            <div class="users-list-w">
                <div class="user-w with-status status-green" v-for="contributor in formatContributors(session)">
                    <div class="user-avatar-w">
                        <div class="user-avatar"><img alt="" :src="contributor.avatar"></div>
                    </div>
                    <div class="user-name">
                        <h6 class="user-title">{{contributor.name}}</h6>
                        <div class="user-role ">{{contributor.role}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: [
    'mainUser',
    'session',
    'contributors',
    'totalProducts',
    'type',
    'subtype'
  ],
  data () {
    return {
      statusFilters: [
        { name: 'All', key: '' },
        { name: 'Open', key: '1' },
        { name: 'Closed', key: '0' },
        { name: 'Cancelled', key: '3' },
        { name: 'Importing', key: '4' },
        { name: 'Processing', key: '5' }

      ]
    }
  },
  computed: {
    products () {
      return this.totalProducts
    }
  },
  methods: {
    getSessionID: function (session) {
      if (session) {
        if (session.id_photodesk_session) {
          return session.id_photodesk_session
        }
        if (session.id_copydesk_session) {
          return session.id_copydesk_session
        }
        if (session.id_pretouchdesk_session) {
          return session.id_pretouchdesk_session
        }
        if (session.id_retouchdesk_session) {
          return session.id_retouchdesk_session
        }
      }
    },
    formatChannelAvatar: function (session) {
      return (
        'background-image: url(' +
        session.channel_logo +
        '); background-size:100%; background-repeat: repeat-y;'
      )
    },
    formatContributors: function (session) {
      var self = this
      if (session.contributors == null) return false
      var contributorArray = session.contributors.split(',')
      let c1 = [...new Set(contributorArray)]
      let contributors = c1.map(function (value, index, array) {
        var formattedContributor = value.split('~')
        return {
          role: formattedContributor[0],
          avatar: formattedContributor[1],
          name: formattedContributor[2]
        }
      })
      return contributors
    },
    closeSession: function () {
      var self = this

      const url = self.type + '/session/update'
      let data = {
        id_photodesk_session: self.session.id_photodesk_session,
        id_pretouchdesk_session: self.session.id_pretouchdesk_session,
        id_retouchdesk_session: self.session.id_retouchdesk_session,
        id_copydesk_session: self.session.id_copydesk_session,
        status: 0
      }

      self.loading = true
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.$http.get('/auth/profile')
            .then(function (response) {
              self.$store.dispatch('updateUser', response.data)
              self.$store.dispatch('updateOpenSessions', response.data.open_sessions)
              self.$store.dispatch('updateClientVariables', response.data.variables)
            })

          location.reload()
        })
        .catch(function (error) {
          self.loading = false
        })
    },
    formatStatus: function (status) {
      var self = this
      let result = self.statusFilters.find(
        filter => parseInt(filter.key) === status
      )
      return result.name.toLowerCase()
    }
  }
}
</script>

<style>
.open {
  color: #75da62 !important;
}
.closed {
  color: #23b7e5 !important;
}
.cancelled {
  color: #ddd;
}
.users-list-w {
  padding: 10px;
}
.pricing-plans {
  background-color: #fff;
  border-right: 1px solid #ddd;
  height: calc(100vh - 54px);
}
.pricing-plan .plan-description h6 {
  text-transform: uppercase;
  letter-spacing: 2px;
  margin-top: 10px;
  font-size: 0.9rem;
}
.plan-description {
  background-color: #fff;
  padding: 10px;
}
.plan-image > div {
  font-size: 50px;
  color: #047bf8;
}
.plan-name {
  font-weight: 600;
}
.pricing-plan .plan-head {
  background-color: #fff;
  padding-top: 10px;
}
.pricing-plan,
.pricing-plan .plan-body {
  background-color: #fff;
}

.pricing-plan .plan-name {
  padding-bottom: 10px;
}
.pricing-plan .plan-price-w {
  padding-top: 10px;
  margin-bottom: 10px;
}
.pricing-plan .plan-btn-w {
  padding-bottom: 10px;
  display: inline-block;
  padding-right: 10px;
  padding-left: 10px;
}
.support-ticket-info {
  background-color: #f6f7f9;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#eff1f7),
    to(#f9fafc)
  );
  background: linear-gradient(to bottom, #eff1f7, #f9fafc);
  padding: 10px 20px;
  border-radius: 6px;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 250px;
  flex: 0 0 250px;
  position: relative;
}
.support-ticket-info .close-ticket-info {
  position: absolute;
  top: 10px;
  right: 15px;
  color: #047bf8;
  text-decoration: none;
  font-size: 20px;
}
.support-ticket-info .customer {
  text-align: center;
  /* padding-bottom: 20px; */
  margin-bottom: 30px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.support-ticket-info .customer .avatar {
  margin-bottom: 10px;
}
.support-ticket-info .customer .customer-name {
  margin-bottom: 5px;
}
.support-ticket-info .info-section {
  padding: 0px;
  margin-bottom: 40px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.support-ticket-info .customer .avatar img {
  border-radius: 50px;
  width: 100px;
  height: auto;
}

.support-ticket-info .customer .customer-name {
  margin-bottom: 5px;
}

.support-ticket-info .customer .customer-tickets {
  color: #636c72;
}

.support-ticket-info .info-header {
  color: #047bf8;
  text-align: center;
  margin-bottom: 15px;
}

.support-ticket-info .info-section .label {
  color: #636c72;
  display: block;
  margin-bottom: 5px;
}
.support-ticket-info .info-section .value {
  display: block;
}

.support-ticket-info .info-section:last-child {
  margin-bottom: 0px;
  border-bottom: none;
  padding-bottom: 0px;
}

.support-ticket-info ul.users-list {
  list-style: none;
  padding: 0px;
  margin: 0px;
  margin-bottom: 20px;
}

.support-ticket-info ul.users-list li {
  margin-bottom: 10px;
}

.support-ticket-info ul.users-list.as-tiles {
  display: inline-block;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.support-ticket-info ul.users-list.as-tiles li {
  text-align: center;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 47%;
  flex: 0 0 47%;
}

.support-ticket-info ul.users-list.as-tiles li a {
  display: block;
  background-color: #fff;
  -webkit-box-shadow: 0px 2px 4px rgba(126, 142, 177, 0.12);
  box-shadow: 0px 2px 4px rgba(126, 142, 177, 0.12);
  padding: 10px;
  border-radius: 6px;
  margin: 0px;
  text-decoration: none;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.support-ticket-info ul.users-list.as-tiles li a span {
  display: block;
  border-bottom: none;
  color: #3e4b5b;
  font-size: 0.72rem;
}

.support-ticket-info ul.users-list.as-tiles li a .avatar {
  margin: 0px;
  width: 50px;
  height: 50px;
  margin-bottom: 5px;
  background-size: cover;
  display: inline-block;
  border-radius: 50px;
}

.support-ticket-info ul.users-list.as-tiles li a i {
  margin-right: 0px;
  margin-bottom: 10px;
}

.support-ticket-info ul.users-list.as-tiles li a:hover {
  -webkit-box-shadow: 0px 5px 12px rgba(126, 142, 177, 0.2);
  box-shadow: 0px 5px 12px rgba(126, 142, 177, 0.2);
  -webkit-transform: translateY(-3px);
  transform: translateY(-3px);
}

.support-ticket-info ul.users-list.as-tiles li a:hover span {
  color: #047bf8;
}
</style>
